import './underwriting.submission.page.container.scss';

import { NextButton, PreviousButton } from '../../presentation';
import { PropsWithChildren, ReactNode } from 'react';

import { Stack } from '@mui/system';
import { Typography } from '@mui/material';

interface IProps extends PropsWithChildren {
  title: string;
  footer?: ReactNode;
  footerRight?: ReactNode;
  footerLeft?: ReactNode;
  headerRight?: ReactNode;
  onNext?: () => void;
  onNextDisabled?: boolean;
  onPrevious?: () => void;
}

export const UnderwritingSubmissionPageContainer = ({
  title,
  footer,
  headerRight,
  footerLeft,
  footerRight,
  children,
  onNext,
  onNextDisabled = false,
  onPrevious,
}: IProps) => {
  return (
    <Stack flexGrow={1} overflow={'hidden'}>
      <Stack marginBottom={2} flexDirection={'row'}>
        <Stack>
          <Typography
            variant="h3"
            color="secondary"
            className="main-title-page"
          >
            {title}
          </Typography>
        </Stack>
        <Stack flexGrow={1} />
        {headerRight && <Stack>{headerRight}</Stack>}
      </Stack>
      <Stack flexGrow={1} overflow={'auto'} padding={'0 10px'}>
        {children}
      </Stack>
      {(footer || footerLeft || footerRight || onNext || onPrevious) && (
        <Stack
          justifyContent={'space-between'}
          flexDirection={'row'}
          marginTop={2}
          alignItems={'center'}
        >
          {(footerLeft || footerRight || onNext || onPrevious) && (
            <Stack justifySelf={'flex-start'} flexDirection={'row'}>
              {footerLeft}
            </Stack>
          )}
          {footer && <Stack>{footer}</Stack>}
          {(footerRight || footerLeft || onNext || onNext || onPrevious) && (
            <Stack
              justifySelf={'flex-end'}
              flexDirection={'row'}
              padding={'0px 30px 20px 10px '}
            >
              {footerRight}
              {onPrevious ? (
                <PreviousButton onClick={onPrevious} />
              ) : (
                <PreviousButton onClick={onPrevious} disabled={true} />
              )}
              {onNext ? (
                <NextButton onClick={onNext} />
              ) : (
                <NextButton onClick={onNext} disabled={true} />
              )}
            </Stack>
          )}
        </Stack>
      )}
    </Stack>
  );
};
